export default "__VITE_ASSET__280656cd__"